const JsModal = {
	init () {

		/*              __
					   / _)
				.-^^^-/ /
			__/       /
			<__.|_|-|_|

			The Emagine Dinosaur says; "Modals are better with Ajax".
		*/

		if ( $('.ajaxModal').length ) {

			// Smooth open, but won't work if we need to track history
			// $(document).on('click', 'a[data-ajax-open]', function(e) {
			//   e.preventDefault();
			//   var $modal = $('#' + $(this).data('ajax-open'));
			//   $.ajax({
			//     type: 'get',
			//     url: $(this).attr('href'),
			//     success: function(html) {
			//       var $html = $(html);
			//       $modal.find('.c-modal-content').html($html);
			//       $html.foundation(); // Initialize foundation on the new html content.
			//       $modal.trigger('open');
			//     }
			//   });
			// });

			// This will work if we need to track history
			$('.ajaxModal').on('open.zf.reveal', function () {

				let activeModal = $(this);

				setTimeout(function() {
					$.ajax({
						async: true,
						type: 'get',
						url: activeModal.data('ajax-data'),
					}).done(function(content) {
							activeModal.find('.c-modal-content').html(content);
							activeModal.trigger('resizeme.zf.reveal');

							setTimeout(() => {

                setTimeout(() => {
  								$('.fitvid').fitVids();
                }, 500);

								if( activeModal.find('.c-card-slider').length ) {

									// Calculate whether or not card images should have portrait override class
									// first loop through all sliders on page
									activeModal.find('.c-card-slider').find('.c-slide').each( function(key, value) {
										// Find actual image
										let targetImage = $(value).find('img');

										// Create test image, to compare dimensions
										let testImage = new Image();
										testImage.src = targetImage.attr('src');

										let imgWidth = testImage.naturalWidth;
										let imgHeight = testImage.naturalHeight;

										if ( imgHeight !== 0 ) {
											if ( imgHeight >= imgWidth ) {
												$(value).find('img').addClass('portrait');
											}
										}
									});

									// Init Slider
									activeModal.find('.c-card-slider').slick({
										// Lazyload all the things
										lazyLoad: 'ondemand',
										slidesToShow: 1,
										slidesToScroll: 1,
										arrows: true,
										prevArrow: '<div class="slick-prev" aria-hidden="true"><div>',
										nextArrow: '<div class="slick-next" aria-hidden="true"><div>',
										dots: false,
										draggable: true,
										pauseOnFocus: false,
										pauseOnHover: false,
										fade: true,
										infinite: true,
										cssEase: 'linear'
									});

									activeModal.find('.c-card-slider').resize();
								}

				                if ( activeModal.find('.c-gallery').length ) {
									activeModal.find('.c-gallery').lightGallery({
										selector: '.gallery',
										thumbnail: true,
										// showThumbByDefault: false
									});
				                }

              if ( activeModal.find('.fitvid').length ) {
                if ( $('.deferred-video').length > 0 ) {

                  $('.deferred-video').each( function(key, value) {

                    if ( $(value).data('src') ) {

                      let targetSrc = $(value).data('src');
                      $(value).attr('src', targetSrc);
                    }

                  });
                }

                $('.fitvid').fitVids();
              }

				                if ( activeModal.find('.timeline-text__read-more').length ) {
									activeModal.find('.timeline-text__read-more').click(function() {
					                    activeModal.find('.timeline-text__read-more').addClass('hide');
					                    activeModal.find('.timeline__text--short').addClass('hide');
					                    activeModal.find('.timeline__text--long').removeClass('hide');
									})
				                }

				                $(document).foundation();
								Foundation.reInit('equalizer');
							}, 500);
						});
				}, 500);

			});

		}

		// We need to reinit equalizer inside modals once they've been opened.
		// $('.reveal').on('open.zf.reveal', function () {

		//   setTimeout(() => {

		//       if( $('.reveal').find('.slick-slider').length ) {
		//         $('.slick-slider').resize();
		//       }

		//       Foundation.reInit('equalizer');

		//   }, 250);

		// });
	}
};

export default JsModal;



// WEBPACK FOOTER //
// ./src/components/03-ui/modal/modal.js